import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass } from '../../../../helper/classes'
import logoImg from '../../../../../assets/images/logo1.png'
import ExternalLink from '../../../commonInterface/externalLink'

function AppInfoAddOn () {
  return (
    <ExternalLink url={'https://learnobit.com'}>
      <img src={logoImg} alt={'LearnObit'} css={css`margin: auto; width: auto; height: auto; max-height: 160px;`} />
    </ExternalLink>
  )
}

const AppInfoAddOnBoxClass = new BoxClass(AppInfoAddOn, 'Go to LearnObit', null, 'sharing', { order: 1, defaultOpen: true })

export default AppInfoAddOnBoxClass
